import styled from '@emotion/styled'

export const GenericContentContainer = styled.div`


`